import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import Select, { SelectProps } from './Select'
import { Betriebsstellenart } from '../../types'

export interface BetriebsstellenartFieldProps extends SelectProps {
  typen?: readonly Betriebsstellenart[]
}

/**
 * A select field for choosing a Betriebsstellenart according to Deutsche Bahn Ril 100
 */
const BetriebsstellenartField = forwardRef<
  HTMLSelectElement,
  BetriebsstellenartFieldProps
>(
  (
    {
      typen,
      label = 'Betriebsstellenart',
      variant = 'solid',
      errors,
      'data-testid': testId,
      className,
      selectClassName,
      value,
      ...props
    },
    ref
  ) => {
    const { t } = useTranslation('ui-common')
    const typenToUse = typen ?? Object.values(Betriebsstellenart)

    return (
      <Select
        {...props}
        ref={ref}
        label={label}
        variant={variant}
        errors={errors}
        data-testid={testId}
        className={className}
        selectClassName={selectClassName}
        value={value}
      >
        <option value="" data-testid={`${testId}-option-please-select`}>
          {t('please_select')}
        </option>
        {typenToUse.map((typ) => (
          <option key={typ} value={typ} data-testid={`${testId}-option-${typ}`}>
            {typ}
          </option>
        ))}
      </Select>
    )
  }
)

BetriebsstellenartField.displayName = 'BetriebsstellenartField'

export default BetriebsstellenartField
